export default __webpack_public_path__ + "static/media/virtuallogo.58e3f567.svg";